// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"43":"2a0f50bc","99":"8584a994","223":"06161fca","425":"9d9d22f1","546":"1684b28b","623":"29b50342","788":"31749d12","994":"d79ffe34"}[chunkId] + ".js";
};